import { Box, Button, FormControl, FormLabel, Input, Switch } from "@chakra-ui/react";
import LocationAutocomplete from "components/elements/LocationAutocomplete";
import PageHeader from "components/layout/PageHeader";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useEffect, useState } from "react";
import { apiRequest } from "utils/api";
import StepDescription from "../StepDescription";
import StepTitle from "../StepTitle";
import { useCurrentUserQuery } from "modules/tenant/queries/use-current-user-query";

const CompanyAddress = () => {
  const { user } = useTenant();
  const { refetch } = useCurrentUserQuery();
  const company = user.company || {};
  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState<any>(company.address);
  const [mailingAddress, setMailingAddress] = useState<any>(company.mailing_address);
  const [sameMailing, setSameMailing] = useState(true);
  const [companyName, setCompanyName] = useState(company.name || "");

  const updateCompany = async () => {
    try {
      setIsLoading(true);
      await apiRequest("/supabase/companies/update", {
        values: {
          address,
          mailing_address: sameMailing ? address : mailingAddress,
        },
      });
      await refetch();
      // setStep(steps[steps.indexOf(step) + 1]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      user.company.address &&
      user.company.mailing_address &&
      user.company.address.formatted !== user.company.mailing_address.formatted
    ) {
      setSameMailing(false);
    }
  }, [user]);

  return (
    <Box py="34px" px="26px" flex="1">
      <PageHeader title="Add Company Details" hideUser />

      <Box>
        <StepTitle>Company Location</StepTitle>
        <StepDescription>Add the address for your business.</StepDescription>
        <FormControl maxW="480px" mb="24px">
          <FormLabel>Company Name</FormLabel>
          <Input
            value={companyName}
            onChange={ev => setCompanyName(ev.target.value)}
            // isInvalid={invalidFields.includes("fundingDate")}
            placeholder="West Coast Builds"
            variant="primary"
          />
        </FormControl>

        <FormControl maxW="480px" mb="24px">
          <FormLabel>Address</FormLabel>
          <LocationAutocomplete onChange={setAddress} defaultValue={(address || {}).formatted} />
        </FormControl>
      </Box>

      <FormLabel>Mailing Address</FormLabel>
      <FormControl display="flex" alignItems="center" mb="24px">
        <Switch
          isChecked={sameMailing}
          id="same-mailing"
          onChange={ev => setSameMailing(ev.target.checked)}
        />
        <FormLabel htmlFor="same-mailing" fontWeight="500" fontSize="12px" ml="20px" mb="0px">
          Same as Company Address
        </FormLabel>
      </FormControl>

      {!sameMailing && (
        <FormControl maxW="480px" mb="24px">
          <LocationAutocomplete
            onChange={setMailingAddress}
            defaultValue={(mailingAddress || {}).formatted}
          />
        </FormControl>
      )}

      <Button size="sm" mr="16px" isLoading={isLoading} onClick={updateCompany}>
        Continue
      </Button>
    </Box>
  );
};

export default CompanyAddress;
